
// Pagina cotizaciones 
import React from 'react';
import QuotationList from '../components/QuotationList';
import QuotationsDetails from '../components/QuotationsDetails';
import { useUser } from '../UserContext';
import { Box, Typography } from '@mui/material';


export default function Quotations() {
  const [selectedQuotation, setSelectedQuotation] = React.useState(null);

  return (
    <section>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Lista de Cotización rápida</Typography>
      </Box>

      {selectedQuotation ? (
        <QuotationsDetails
          quotation={selectedQuotation}
          onBack={() => setSelectedQuotation(null)}
        />
      ) : (
        <QuotationList
          onSelect={setSelectedQuotation}
        />
      )}
    </section>
  );
}
